import { useLocales } from '@shared/locales'
import { Button, Flex } from 'antd'
import { Add } from 'iconsax-react'
import { useState } from 'react'

import { AddEditLead } from './AddEditLead'

type ModalType = 'add'

export const LeadsHeader = () => {
  const { t } = useLocales()
  const [modalType, setModalType] = useState<ModalType | null>(null)

  return (
    <Flex justify="flex-end">
      <Button
        onClick={() => setModalType('add')}
        icon={<Add size={16} />}
        type="primary"
      >
        {t('contacts.add_contact')}
      </Button>

      {modalType === 'add' && (
        <AddEditLead open onCancel={() => setModalType(null)} />
      )}
    </Flex>
  )
}
